import {FC} from "react"
import {AdminOrganizationsTable} from "../../components/admin/AdminOrganizationsTable"
import {LoadEventsEnum} from "../../types/enums";
import {OrganizationsAndParticipantsProvider} from "../../providers/OrganizationsAndParticipantsProvider";

export const OrganizationsListPage: FC = () => {
  return (
    <OrganizationsAndParticipantsProvider type={LoadEventsEnum.organizations}>
      <AdminOrganizationsTable/>
    </OrganizationsAndParticipantsProvider>
  )
};